import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc15964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapsible-section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["arrow", { open: _ctx.isOpen }])
      }, "▶", 2 /* CLASS */),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1 /* TEXT */)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.isOpen]
    ])
  ]))
}